import Vue from "vue";
import VueRouter from "vue-router";
import axios from 'axios'
import {
    BootstrapVue,
    IconsPlugin,
    BootstrapVueIcons
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VCalendar from 'v-calendar';
import Toasted from 'vue-toasted';
import vSelect from 'vue-select'
import vMultiselect from 'vue-multiselect'
import JsonExcel from 'vue-json-excel'

import 'vue-select/dist/vue-select.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.prototype.$http = axios




Vue.component('v-select', vSelect);
Vue.component('v-multiselect', vMultiselect);
Vue.component('downloadExcel', JsonExcel);

Vue.use(Toasted);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(BootstrapVueIcons);
Vue.use(VueRouter);
Vue.use(require('vue-moment'));
Vue.use(VCalendar);

import Connection from "../views/Connection.vue";
import Home from "../views/Home.vue";
import NotFound from "../views/NotFound.vue";
import Deconnection from "../views/Deconnection.vue";
import Account from "../views/Account.vue";
import Help from "../views/Help.vue";
import UserManager from "../views/UserManager.vue";
import ProjetManager from "../views/ProjetManager.vue";
import Leave from "../views/Leave.vue";
import Report from "../views/Report.vue";
import Holidays from "../views/Holidays.vue";
import Dashboard from "../views/Dashboard.vue"
import Advance from "../views/Advance.vue"

const routes = [{
        path: "/connexion",
        name: "Connection",
        component: Connection
    },
    {
        path: "/compte",
        name: "account",
        component: Account
    },
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard
    },
    {
        path: "/aide",
        name: "Aide",
        component: Help
    },
    {
        path: "/deconnexion",
        name: "Deconnection",
        component: Deconnection
    },
    {
        path: "/utilisateurs",
        name: "UserManager",
        component: UserManager
    },
    {
        path: "/projets",
        name: "ProjetManager",
        component: ProjetManager
    },
    {
        path: "/rapport",
        name: "Rapport",
        component: Report
    },
    {
        path: "/advance",
        name: "Advance",
        component: Advance
    },
    {
        path: "/conges",
        name: "Conges",
        component: Leave
    },
    {
        path: "/holidays",
        name: "Holidays",
        component: Holidays
    },
    {
        path: "*",
        name: "NotFound",
        component: NotFound
    },

];

const router = new VueRouter({
    routes
});

export default router;